import { render, staticRenderFns } from "./ApproverSettings.vue?vue&type=template&id=12f0ca04&"
import script from "./ApproverSettings.vue?vue&type=script&lang=js&"
export * from "./ApproverSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports